import APIService from '../api';
import { Campaign } from '@/models/marketingCenter/freeCoins';
import { IQueryPaginationOptions } from '@/models/general';

export default class OfferFreeCoinsService extends APIService {
  listActiveOfferFreeCoins(
    params: Record<string, any> = {
      filters: 'firstcoin_campaign.status:active'
    }
  ) {
    return this.get('/admin/firstcoin-campaign', { params });
  }

  listOfferFreeCoins(query?: string, data?: any) {
    return this.get(query || '/admin/firstcoin-campaign', query ? {} : data);
  }

  createOfferFreeCoin(data: Campaign) {
    return this.post('/admin/firstcoin-campaign', data);
  }

  updateOfferFreeCoin(id: string, data: Partial<Campaign>) {
    return this.put(`/admin/firstcoin-campaign/${id}`, data);
  }

  listOfferFreeCoinsCustomers(id: string, options: IQueryPaginationOptions) {
    return this.getQueryPagination(
      `/admin/firstcoin-campaign/${id}/customer`,
      options
    );
  }
}
